import { from as observableFrom, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { rentalObjectCommand } from '../../command/rental-object.command';

@Injectable()
export class ShowRentalObjectInvoicesCommandHandler implements ICommandHandler {
  constructor(private _navigationService: NavigationService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === rentalObjectCommand.showInvoices && command.context;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return observableFrom(this._navigationService.navigateChild([command.context.id, 'invoices']));
    }
  }
}
